export default __webpack_public_path__ + "static/media/8-head.faff799f.png";